module.exports = __webpack_public_path__ + "static/media/ID.26557217.svg";